import React, { useState, useEffect } from "react";
import welcome from "@/assets/image/welcome.png";
import "./dashboard.scss";

const Dashbord = () => {
  return (
    <div className="dashboard-wrapper">
      <div className="roms">
        <img src={welcome} className="romsIcon" alt="" />
        欢迎使用95AI管理平台！
      </div>
    </div>
  );
};

export default Dashbord;
